import { render, staticRenderFns } from "./AksesCheckbox.vue?vue&type=template&id=15fee889&scoped=true"
import script from "./AksesCheckbox.vue?vue&type=script&lang=js"
export * from "./AksesCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AksesCheckbox.vue?vue&type=style&index=0&id=15fee889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fee889",
  null
  
)

export default component.exports